import {
  Component,
  OnInit,
  OnDestroy,
  Inject,
  Optional,
  ElementRef,
  ViewChild
} from '@angular/core';
import { Router } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { BsModalService } from 'ngx-bootstrap/modal';
import { ClipboardService } from 'ngx-clipboard';
import { CommonService } from '../../services/common.service';
import { ToasterService } from '../../services/toaster.service';
import { API_URLS, APIENDPOINT } from '../../../../core/api-url.enum';
import { ApiCallService } from '../../../../services/api-call.service';
import { CommonEnums } from '../../../../enums/comman.enums';
import {
  MAT_BOTTOM_SHEET_DATA,
  MatBottomSheetRef
} from '@angular/material/bottom-sheet';
import { FEED_TYPE, MESSAGES, SHARED_DIALOG_CONSTS } from '@shared/components/shareddialog/shareddialog.constants';
import { PERMISSION_KEYS } from '@shared/constants/permissions.contant';
import { NEW_POST_CONST } from '@modules/dashboard/components/new-post/newposts/constants';
import { AuthService } from '@core/auth.service';
import { AlertModalComponent } from '@components/alert-modal/alert-modal.component';
import { take } from 'rxjs/operators';
import { Application } from '@enums/application.enums';
import { getChatRoomUiLabels } from '@modules/forum/constants/forums.constant';

@Component({
  selector: 'app-shareddialog',
  templateUrl: './shareddialog.component.html',
  styleUrls: ['./shareddialog.component.scss']
})
export class ShareddialogComponent implements OnInit, OnDestroy {
  shortendURL = '';
  isLoading = false;
  shareDescription = '';
  shareTitleEmail = '';
  shareDescriptionEmail = '';
  modalInfo = {
    isMyProfile: true,
    otherUserEmail: '',
    userName: '',
    firstName: '',
    lastName: '',
    profileImage: '',
    pk: '',
    sk: '',
    type: '',
    originalSk: '',
    originalPk: '',
    sharingResource: '',
    gsi4pk: '',
    image: '',
    feedType: '',
    isSameCreatorProfile: false,
    post_sk: null,
    isDownloadable: false,
    portfolioMsg: '',
    is_private: false,
  };
  isPrivateAccount = false;
  consts = SHARED_DIALOG_CONSTS;
  FeedType = FEED_TYPE
  NEW_POST_CONST = NEW_POST_CONST;

  private twitterCaptureCleanup: (() => void) | null = null;

  @ViewChild('twitterShareWrap', { read: ElementRef })
  set twitterShareWrap(ref: ElementRef<HTMLElement> | undefined) {
    this.removeTwitterCaptureListener();
    if (!ref?.nativeElement || !this.cs.isBrowser) {
      return;
    }
    const el = ref.nativeElement;
    const handler = (e: MouseEvent) => {
      const target = e.target as HTMLElement | null;
      if (!target?.closest?.('button.sb-wrapper')) {
        return;
      }
      e.preventDefault();
      e.stopPropagation();
      this.showTwitterShareLoginHint();
    };
    el.addEventListener('click', handler, true);
    this.twitterCaptureCleanup = () => {
      el.removeEventListener('click', handler, true);
      this.twitterCaptureCleanup = null;
    };
  }

  constructor(
    private readonly modalService: BsModalService,
    private readonly router: Router,
    public readonly cs: CommonService,
    private readonly _clipboardService: ClipboardService,
    private readonly apiCallService: ApiCallService,
    private readonly toasterService: ToasterService,
    private readonly titleService: Title,
    private readonly authService: AuthService,
    @Optional()
    private bottomSheetRef: MatBottomSheetRef<ShareddialogComponent>,
    @Inject(MAT_BOTTOM_SHEET_DATA) private data: any = {}
  ) {}

  ngOnInit() {
    if (this.cs.isBrowser) {
      const data = this.data?.modalInfo
        ? this.data?.modalInfo
        : this.modalService.config?.initialState;

      this.modalInfo = Object.assign({
        isMyProfile: data?.isMyProfile,
        otherUserEmail: data?.otherUserEmail,
        userName: data?.username,
        firstName: data?.firstName,
        lastName: data?.lastName,
        pk: data?.pk,
        sk: data?.sk,
        type: data?.type,
        originalSk: data?.originalSk,
        originalPk: data?.originalPk,
        sharingResource: data?.sharingResource,
        gsi4pk: data?.gsi4pk,
        image: data?.image,
        feedType: data?.feedType,
        isSameCreatorProfile: data?.isSameCreatorProfile,
        isDownloadable: data?.isDownloadable || false,
        post_sk: data?.post_sk,
        portfolioMsg: data?.portfolioMsg,
        is_private: data?.is_private
      });
      this.isPrivateAccount = this.resolveIsPrivateAccount(data);
      if (this.modalService.config?.initialState?.isShortendURL) {
        this.shortendURL = this.modalService.config?.initialState
          ?.referralURL as string;
      } else if (data?.isReferral) {
        const referralURL = data?.referralURL as string;
        this.updateUrlToShortenUrl(referralURL);
      } else if (this.modalInfo.sharingResource === NEW_POST_CONST.LIVE_STREAM) {
        this.updateUrlToShortenUrl(data.url as string);
      } else if (this.modalInfo.sharingResource === this.consts.ADVERTISEMENT_SHARE) {
        // Handle advertisement sharing - use referralURL directly
        const referralURL = data?.referralURL as string;
        if (referralURL) {
          this.updateUrlToShortenUrl(referralURL);
        }
      } else if (this.modalInfo.sharingResource === this.consts.PORTFOLIO_SHARE) {
        const portfolioUrl = data?.url as string;
        if (portfolioUrl) {
          const fullUrl = portfolioUrl.startsWith('http') 
            ? portfolioUrl 
            : `${window.location.origin}/${portfolioUrl}`;
          this.updateUrlToShortenUrl(fullUrl);
        }
      } else if (this.modalInfo.type === 'forum') {
        this.modalInfo.sharingResource = 'forumShare';
        const referralURL = this.cs.navigateToPostDetail(
          '/post/forum',
          this.cs.encodeToUTF(data?.username),
          this.cs.encodeToUTF(data?.sk),
          this.cs.encodeToUTF(data?.gsi4pk),
          false,
          undefined,
          null,
          data.pk
        );
        this.updateUrlToShortenUrl(referralURL!);
      } else if (this.modalInfo.sharingResource === this.consts.eventTicket) {
        const eventUrl = data?.url as string;
        if (eventUrl) {
          const fullUrl = eventUrl.startsWith('http') 
            ? eventUrl 
            : `${window.location.origin}/${eventUrl}`;
          this.updateUrlToShortenUrl(fullUrl);
        }
      } else {
        const urlPart = this.cs.navigateToPostDetail(
          '/post',
          this.cs.encodeToUTF(data?.username!),
          this.cs.encodeToUTF(data?.sk),
          this.cs.encodeToUTF(data?.gsi4pk),
          false,
          -1,
          data?.feedType,
          data.pk
        );
        this.updateUrlToShortenUrl(urlPart!, data.referralURL);
      }

      this.getShareDescription();
    }
  }

  getShareDescription() {
    if (this.modalInfo.sharingResource === 'postShare' || this.modalInfo.sharingResource === this.consts.WELCOME_VIDEO_SHARE || this.modalInfo.sharingResource === this.consts.MERCHANDISE_STORE ) {
      this.shareTitleEmail = 'Check out what I found';
      if (this.modalInfo.isMyProfile) {
        this.shareDescription = 'Check out my latest content on TopFan';
      } else {
        this.shareDescription = `Check out this amazing content I found from ${this.fullName} on TopFans`;
      }
      this.shareDescriptionEmail = this.shareDescription;
    } else if (this.modalInfo.sharingResource === NEW_POST_CONST.LIVE_STREAM) {
      this.shareTitleEmail = 'Check out my Livestream';
      if (this.modalInfo.isMyProfile) {
        this.shareDescription = 'Check out my livestream on TopFan';
      } else {
        this.shareDescription = `Check out ${this.fullName}'s livestream on TopFan`;
      }
      this.shareDescriptionEmail = this.shareDescription;
    } else if (this.modalInfo.sharingResource === this.consts.ADVERTISEMENT_SHARE) {
      this.shareTitleEmail = this.consts.ADVERTISEMENT_SHARE_TITLE.replace('{name}', this.fullName);
      this.shareDescription = this.consts.ADVERTISEMENT_SHARE_DESCRIPTION.replace('{name}', this.fullName);
      this.shareDescriptionEmail = this.shareDescription;
    } else if (this.modalInfo.sharingResource === 'referralShare') {
      this.shareTitleEmail = 'You should check out TopFan.com';
      this.shareDescription =
        'Hey! I recently started using TopFan. It’s a great platform for creators to build a direct relationship with their best fans.\n\nCheck it out for yourself, by clicking this link:';
      this.shareDescriptionEmail = this.shareDescription;
    } else if (this.modalInfo.sharingResource === 'pageShare') {
      const currentProfileEmail = this.cs.getMyProfile();
      if (
        currentProfileEmail
          ? this.modalInfo?.otherUserEmail !== currentProfileEmail
          : !this.modalInfo.isSameCreatorProfile
      ) {
        this.shareTitleEmail = `Check out ${this.fullName} on TopFans`;
        this.shareDescription = `Follow ${this.fullName} on TopFan to get their exclusive content and meet other fans.`;
        this.shareDescriptionEmail = this.shareDescription;
      } else {
        this.shareTitleEmail = 'You should check out TopFan.com';
        this.shareDescription =
          'Follow me on TopFan to get my exclusive content and meet other fans';
        this.shareDescriptionEmail = this.shareDescription;
      }
    } else if (this.modalInfo.sharingResource === this.consts.PORTFOLIO_SHARE) {
      const portfolioType = this.modalInfo.portfolioMsg || 'Portfolio';
      if (this.modalInfo.isMyProfile) {
        this.shareTitleEmail = `Check out my ${portfolioType}`;
        this.shareDescription = `Check out my ${portfolioType} on TopFans`;
      } else {
        this.shareTitleEmail = `Check out ${this.fullName}'s ${portfolioType}`;
        this.shareDescription = `Check out ${this.fullName}'s ${portfolioType} on TopFans`;
      }
      this.shareDescriptionEmail = this.shareDescription;
    } else {
      (this.shareTitleEmail = 'You should check out TopFan.com'),
        (this.shareDescription = `Hey everyone! I started using TopFan to create a place to connect with my best fans and to share exclusive content. Make sure to follow me. Check out my site here:`);
      this.shareDescriptionEmail = this.shareDescription;
    }
  }

  ngOnDestroy(): void {
    this.removeTwitterCaptureListener();
  }

  private removeTwitterCaptureListener(): void {
    this.twitterCaptureCleanup?.();
  }

  private showTwitterShareLoginHint(): void {
    const twitterShareUrl = this.buildTwitterShareUrl();
    const initialState = {
      headerLabel: this.consts.TWITTER_SHARE_LOGIN_HINT_TITLE,
      bodyContent: this.consts.TWITTER_SHARE_LOGIN_HINT_BODY,
      confirmBtnLabel: CommonEnums.OK,
      showCrossBtn: true,
      showConfirmationBtn: true,
    };
    const modalRef = this.modalService.show(AlertModalComponent, {
      initialState,
      backdrop: 'static',
    });
    const modalInstance = modalRef.content as AlertModalComponent;
    this.closeDialog();
    setTimeout(() => {
      modalInstance.openModal();
    }, Application.FIVE_HUNDRED);
    modalInstance.confirmed.pipe(take(Application.ONE)).subscribe(() => {
      if (twitterShareUrl) {
        window.open(twitterShareUrl, '_blank', 'noopener,noreferrer');
        this.setCountOfSharePost();
      }
      modalRef.hide();
    });
    modalInstance.canceled.pipe(take(Application.ONE)).subscribe(() => modalRef.hide());
  }

  private buildTwitterShareUrl(): string | null {
    if (!this.shortendURL) {
      return null;
    }
    const text = this.shareDescription ? `${this.shareDescription}\n` : '';
    return `https://twitter.com/intent/tweet?text=${encodeURIComponent(text)}&url=${encodeURIComponent(this.shortendURL)}`;
  }

  closeDialog() {
    if (this.data?.modalInfo) {
      this.bottomSheetRef.dismiss();
    }
    this.titleService.setTitle(CommonEnums.defaultTitle);
    this.modalService.hide();
  }

  copyReferralLink(sharingResource?): void {
    if (this.shortendURL) {
      this._clipboardService.copy(this.shortendURL);
      if (!sharingResource) {
        this.cs.showSuccessMessage(MESSAGES.LINK_COPIED);
      } else if (sharingResource === this.consts.MERCHANDISE_STORE) {
        this.cs.showSuccessMessage(MESSAGES.LINK_COPIED);
      } else if (sharingResource === 'referralShare') {
        this.cs.showSuccessMessage(`Referral link copied.`);
      } else if (sharingResource === 'pageShare') {
        this.cs.showSuccessMessage(
          `${this.fullName}’s page link copied.`
        );
      } else if (sharingResource === 'postShare') {
        this.cs.showSuccessMessage(
          `${this.fullName}’s post link copied.`
        );
      } else if (sharingResource === NEW_POST_CONST.LIVE_STREAM) {
        this.cs.showSuccessMessage(
          `${this.fullName}’s livestream link copied.`
        );
      } else if (sharingResource === this.consts.WELCOME_VIDEO_SHARE) {
        this.cs.showSuccessMessage(
          `${this.fullName}’s welcome message link copied.`
        );
      } else if (sharingResource === 'forumShare') {
        this.cs.showSuccessMessage(
          `${this.fullName}'s ${this.chatRoomLabel} link copied.`
        );
      } else if (sharingResource === this.consts.ADVERTISEMENT_SHARE) {
        this.cs.showSuccessMessage(
          this.consts.ADVERTISEMENT_LINK_COPIED.replace('{name}', this.fullName)
        );
      } else if (sharingResource === this.consts.PORTFOLIO_SHARE) {
        const portfolioType = this.modalInfo.portfolioMsg || 'Portfolio';
        this.cs.showSuccessMessage(
          `${this.fullName}'s ${portfolioType} link copied.`
        );
      }
      this.setCountOfSharePost();
    } else {
      this.cs.showErrorMessage('URL copied successfully');
    }
  }

  navigateToReferral(): void {
    this.titleService.setTitle(CommonEnums.defaultTitle);
    this.modalService.hide();
    if (this.modalInfo.isMyProfile) {
      this.router.navigate(['/dashboard/leaderboard']);
    } else {
      if (this.cs.isWhiteLabelWeb) {
        this.router.navigate([
          `/dashboard/leaderboard/${this.modalInfo.userName}`
        ]);
      } else {
        this.router.navigate([
          `/dashboard/leaderboard/${this.modalInfo.userName}/3`
        ]);
      }
    }
  }

  removeUserPrefix(pk) {
    const regex = /^USER#/;
    // Remove 'USER#' if present and return pk.
    return pk.replace(regex, '');
  }

  setCountOfSharePost(): void {
    if (!this.authService.isAuthenticated()) {
      return;
    }
    if (this.modalInfo.sharingResource === 'postShare' || this.modalInfo.sharingResource === this.consts.WELCOME_VIDEO_SHARE) {
      const sharePostObj = {
        post_user_id:
          this.modalInfo.pk !== 'DISCOVER'
            ? this.removeUserPrefix(this.modalInfo.pk)
            : this.removeUserPrefix(this.modalInfo.originalPk),
        post_id:
          this.modalInfo.pk !== 'DISCOVER'
            ? this.modalInfo.sk
            : this.modalInfo.originalSk
      };
      this.apiCallService
        .post(API_URLS.sharePost, sharePostObj, false)
        .subscribe();
    } else if (this.modalInfo.sharingResource === this.consts.ADVERTISEMENT_SHARE) {
      const sharePostObj = {
        post_user_id: this.modalInfo.otherUserEmail,
        post_id: this.modalInfo.sk,
        is_ad: true
      };
      this.apiCallService
        .post(API_URLS.sharePost, sharePostObj, false)
        .subscribe();
    }
  }

  updateUrlToShortenUrl(urlPart: string, recruitUrl?: string) {
    if (this.cs.isBrowser) {
      this.isLoading = true;
      this.fetchShortenUrl(urlPart, recruitUrl)?.subscribe({
        next: (res) => {
          this.isLoading = false;
          if (res?.status && res?.data) {
            this.shortendURL = `${window.location.origin}/share/${res.data}`;
          } else {
            this.toasterService.showError('Oops something went wrong.');
            this.closeDialog();
          }
        },
        error: () => {
          this.closeDialog();
          this.isLoading = false;
          this.toasterService.showError('Oops something went wrong.');
          this.closeDialog();
        }
      });
    }
  }

  fetchShortenUrl(urlPart: string, recruitUrl?: string) {
    if (this.cs.isBrowser) {
      const url = new URL(urlPart, window.location.origin);
      const payload = {
        url: url.href,
        sk: this.getPostSk(),
        pk: this.modalInfo.originalPk
          ? this.modalInfo.originalPk
          : this.modalInfo.pk
      };
      if (recruitUrl) {
        payload.url = `${url}##${recruitUrl}`;
      }
      if(this.modalInfo.sharingResource === this.consts.MERCHANDISE_STORE) {
        payload['type'] = this.consts.STORE
        payload['monetize_type'] = this.modalInfo?.feedType?.toLowerCase()
      }
      return this.apiCallService.put(
        APIENDPOINT.createShortenUrl(),
        payload,
        false
      );
    }
  }

  getPostSk() {
    let postSk = this.modalInfo?.sk?.split('#');
    if (this.modalInfo.sharingResource === this.consts.MERCHANDISE_STORE) {
      return this.modalInfo?.sk 
    }
    if (this.modalInfo.isDownloadable) {
      return this.modalInfo.post_sk;
    }
    if (this.modalInfo.sharingResource === NEW_POST_CONST.LIVE_STREAM) {
      return this.modalInfo.sk;
    }
    if (this.modalInfo.sharingResource === this.consts.ADVERTISEMENT_SHARE) {
      return this.modalInfo.sk;
    }
    if (this.modalInfo.sharingResource === this.consts.PORTFOLIO_SHARE) {
      return this.modalInfo.sk;
    }
    if (this.modalInfo.sharingResource === this.consts.eventTicket) {
      return this.modalInfo.sk;
    }
    if (postSk[0] === PERMISSION_KEYS.WELCOME_MESSAGE) {
      return postSk.join('#');
    }
    postSk[0] = postSk[0] === 'USER' ? 'USER' : 'POST';
    return postSk.join('#');
  }

  get fullName(): string {
    return `${this.modalInfo.firstName || ''} ${this.modalInfo.lastName || ''}`.trim();
  }

  get chatRoomLabel(): string {
    return getChatRoomUiLabels(
      (this.modalInfo as any)?.chatroom_cta
    ).label;
  }

  private resolveIsPrivateAccount(data: any): boolean {
    if (data?.is_private != null) {
      return !!data.is_private;
    }
    if (this.modalInfo.isMyProfile) {
      return !!this.cs.getLoggedInUser()?.is_private;
    }
    const whiteLabelUser =
      this.cs.getWhiteLabelConfiguration()?.user || this.cs.whiteLabelData?.user;
    return !!whiteLabelUser?.is_private;
  }
}
